<ng-container>
	<div (mouseenter)="enter()" (mouseleave)="leave()" fxLayout="column" fxLayoutAlign="center">
		<div *ngFor="let images of transformImages;index as camara" fxLayout="row" fxLayoutAlign="center">
			<div *ngFor="let image of images;index as frame">
				<div *ngIf="count(frame)">
					<div style="margin: 0 4px">
						<div *ngIf="camara == 0">{{image.description}}</div>
						<img *ngIf="camaras(camara)" [matTooltip]="image.description" [ngStyle]="style" [src]="image.src" alt="">
					</div>
				</div>
			</div>
		</div>
	</div>
</ng-container>
